module.exports = __webpack_public_path__ + "static/media/sky-terrace-7.467d8837.jpg";